import { getExportTypes as api } from "apis/exportTypes";
import { WebApiReduxRequest, HTTP_GET } from "tools/webservice";
import {
  REQUEST_CASE_EXPORT_TYPES,
  RECEIVE_CASE_EXPORT_TYPES,
  ERROR_CASE_EXPORT_TYPES,
} from "typeConstants";

export const getExportTypes = () => WebApiReduxRequest(REQUEST_CASE_EXPORT_TYPES, RECEIVE_CASE_EXPORT_TYPES, ERROR_CASE_EXPORT_TYPES, HTTP_GET, api());
